import type { HTMLAttributes, ReactNode } from 'react'
import React from 'react'
import { Grid, csx } from '@vtex/admin-ui'

import { LayoutFlex } from '../../../../core/components/Layout'

type AppWrapperProps = {
  children: ReactNode
} & HTMLAttributes<HTMLFormElement>

export const AppWrapper = ({ children }: AppWrapperProps) => {
  return (
    <LayoutFlex
      data-testid="turn-list"
      className={csx({
        flexDirection: 'column',
        position: 'relative',
        flex: '1 1 auto',
        height: '100%',
      })}
    >
      <Grid
        templateColumns="1fr 1fr"
        templateRows="1fr auto"
        className={csx({
          flex: '1 1 auto',
          overflow: 'hidden',
          height: '100%',
        })}
      >
        {children}
      </Grid>
    </LayoutFlex>
  )
}
